import utils from '@/mixins/utils.js'
import { filtrarComorbidades } from './functions.js'

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  'Condições de saúde': {
    field: 'comorbidades',
    callback: (value) => {
      return value !== ''
        ? filtrarComorbidades(value)
            .map((c) => c.label)
            .join(', ')
        : ''
    },
  },
  'Médico(A)': {
    field: 'dt_ult_fai_med',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  'Enfermeiro(A)': {
    field: 'dt_ult_fai_enf',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  'Odontólogo(A)': {
    field: 'dt_ult_fao',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Visita: {
    field: 'dt_ult_fvdt',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  'Cadastrado por': 'no_profissional',
}
